/*
  Free Olive Matty Changer promo.
  Adds the Olive Matty to the cart when it qualifies for the automatic
  "Free Olive Matty Changer" discounts, and removes it again if the cart
  stops qualifying. Eligibility comes from templates/cart.free-matty.liquid.
  If the customer removes the changer themselves, it is not re-added this session.
*/
(function () {
  var OLIVE_MATTY_VARIANT_ID = 52213298266395
  var ADDED_KEY = 'freeMattyAutoAdded'
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  var busy = false
  var queued = false

  function storageGet() {
    try {
      return sessionStorage.getItem(ADDED_KEY)
    } catch (e) {
      return null
    }
  }

  function storageSet(value) {
    try {
      if (value) sessionStorage.setItem(ADDED_KEY, '1')
      else sessionStorage.removeItem(ADDED_KEY)
    } catch (e) {}
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw response
      return response.json()
    })
  }

  function refreshCartUI(state) {
    // The cart page form may not be initialised yet on page load, so reload it instead
    if (document.body.classList.contains('template-cart')) {
      window.location.reload()
      return
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }))
    document.dispatchEvent(new CustomEvent('cart:build'))
  }

  function check() {
    if (busy) {
      queued = true
      return
    }
    busy = true

    fetch(root + 'cart?view=free-matty', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json()
      })
      .then(function (status) {
        if (status.eligible && !status.hasMatty) {
          // Already added once and the customer removed it: respect that.
          if (storageGet()) return
          return post('cart/add.js', {
            items: [{ id: OLIVE_MATTY_VARIANT_ID, quantity: 1, properties: { _free_gift: 'olive-matty' } }],
            sections: 'cart-ajax'
          }).then(function (state) {
            storageSet(true)
            refreshCartUI(state)
          })
        }

        if (!status.eligible) {
          storageSet(false)
          if (status.giftKey) {
            return post('cart/change.js', { id: status.giftKey, quantity: 0, sections: 'cart-ajax' }).then(
              refreshCartUI
            )
          }
        }
      })
      .catch(function (error) {
        console.warn('Free Olive Matty promo:', error)
      })
      .finally(function () {
        busy = false
        if (queued) {
          queued = false
          check()
        }
      })
  }

  document.addEventListener('ajaxProduct:added', check)
  document.addEventListener('cart:updated', check)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check)
  } else {
    check()
  }
})()
